export const PGX_TEST_REQUISITION_FORM = 'https://view.publitas.com/invitae/trf899_pgx_order_form/page/1'
